import {DOCUMENT, isPlatformServer } from "@angular/common";
import { ApiService } from "../../services/api.service";

import { Component, OnInit, Input, Inject, PLATFORM_ID, ElementRef, ViewChild, ViewChildren, QueryList } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ComponentRendering } from "@sitecore-jss/sitecore-jss-angular";
import Swiper from "swiper";
import { CustomValidators } from '../../custom-validators/custom-validators';
import { FormDropDownComponent } from "../form-drop-down/form-drop-down.component";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { PageScrollService } from "ngx-page-scroll-core";
// import { Navigation } from "swiper/modules";

@Component({
    selector: "app-contact-form",
    templateUrl: "./contact-form.component.html",
    styleUrls: ["./contact-form.component.scss"],
})
export class ContactFormComponent implements OnInit {
    @Input() rendering: ComponentRendering;
    @ViewChild("progressBar") progressBar: ElementRef<HTMLInputElement>;
    @ViewChildren(FormDropDownComponent) formDropdownComponents: QueryList<FormDropDownComponent>;
    @ViewChild('ContactFormModal', { static: false }) scrollUp!: ElementRef;
    _isPlatformServer: boolean = false;
    swiper: Swiper;
    activeSlide: number;
    activeSlideBalnder: number;
    timeSpan: string;
    url: string;
    individualorCompanyOption: string = "Individuals";
    cooperationOption: string = "yes";
    contactedOption: string = "yes";
    wayofCommunicationOption: string = "phone";
    public maskString: {} = { mask : /^\p{L}+$/u };
    // public maskStringWithSpace: {} = { mask : /^[\p{L}]+(?:\p{Z}[\p{L}]*)?$/u };
    public maskStringWithSpace: {} = { mask : /^([\p{L}]+(?:\p{Z})*)*?$/u };
    public maskNumber: {} = { mask : /^\d*$/ };
    selectPlaceholder:string;
    options: any[] = [];
    dropdown: any;
    sector: any;
    EmailTo: any;
    EmailFrom: any;
    private reCaptchaSubscription: Subscription;
    public LoadingOnSubmit: boolean = false;

    forms: FormGroup[] = [];

    isModal: boolean = false;
    callSuccess: boolean;

    constructor(protected apiService: ApiService, 
        @Inject(PLATFORM_ID) public readonly platformId: string, 
        private fb: FormBuilder, 
        private el: ElementRef,
        public translate: TranslateService,
        private recaptchaV3Service: ReCaptchaV3Service,
        public pageScrollService: PageScrollService,
        @Inject(DOCUMENT) private document: Document) {
        platformId;
    }

    ngOnInit() {
        this._isPlatformServer = isPlatformServer(this.platformId);
        this.activeSlide = 0;
        this.isModal = (this.rendering.fields?.isModal as any)?.value;
        this.sector = (this.rendering.fields?.Sector as any)?.value;
        this.dropdown = this.rendering.fields?.Dropdown as any;
        this.EmailFrom = this.rendering.fields?.EmailFrom as any;
        this.EmailTo = this.rendering.fields?.EmailTo as any;

        this.dropdown?.forEach((option: any) => {
            let item = {
                text: option.fields?.text?.value,
                value: option.fields?.value?.value,
            };
            this.options.push(item);
        });
        if (!this._isPlatformServer) {
            this.translate.get("select").subscribe((text : any) => {
                this.selectPlaceholder = text;
            });
            this.initializeForm();
        }
    }

    ngAfterViewInit(): void {
        var _this = this;
        if (!this._isPlatformServer) {
            this.swiper = new Swiper(".pb-contactForm-swiper", {
                spaceBetween: 4,
                autoHeight: true,
                allowTouchMove: false,
                navigation: {
                    nextEl: ".swiper-button-next1",
                    prevEl: ".swiper-button-prev1",
                },
                on: {
                  slideChange: function() {
                    if (_this.isModal) {
                        _this.scrollUp.nativeElement.scrollTop = _this.scrollUp.nativeElement.offsetTop - 100;
                    }else{
                      _this.pageScrollService.scroll({
                        document: _this.document,
                        scrollTarget: '#pb-contact-form-id',
                        scrollOffset: 200,
                        duration:1,
                      });
                    }
                  }
                },
                // modules: [Navigation],
            });

            const resizeObserver = new ResizeObserver(() => {
                this.swiper.update();
            });
            
            resizeObserver.observe(document.getElementById('contactform-area'));
        }
    }

    initializeForm() {
        if (!this._isPlatformServer) {
            // Slide 0 controls
            const index0Group = this.fb.group({
                    individualControls: this.fb.group({
                        name: ["", Validators.required],
                        surname: ["", Validators.required],
                        fatherName: ["", Validators.required],
                    }),
                    companyControls: this.fb.group({
                        companyName: ["", Validators.required],
                        representative: ["", Validators.required],
                    }),
                    cooperationControls: this.fb.group({
                        tin: ["", [Validators.required, CustomValidators.vat()]],
                    }),
                    toggles: this.fb.group({
                        individualorCompany: ["Individuals"],
                        cooperation: ["yes"],
                    }),
                });

            // Slide 1 controls
            const index1Group = this.fb.group({
                category: this.fb.group({
                    dropDown: ["", Validators.required],
                    area: ["", Validators.required],
                    files: [[]],
                }),
                hasContactedOptionControls: this.fb.group({
                    storeService: ["", Validators.required],
                    person: [""],
                }),
                toggles: this.fb.group({
                    hasContacted: ["yes"],
                }),
            });

            // Slide 2 controls
            const index2Group = this.fb.group({
                phoneControls: this.fb.group({
                    phone: ["", Validators.required],
                }),
                emailControls: this.fb.group({
                    email: ["", [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
                }),
                toggles: this.fb.group({
                    wayofCommunication: [""],
                }),
            });

            // Slide 3 controls
            const index3Group = this.fb.group({
                termsControls: this.fb.group({
                    terms1: [false, [Validators.required, Validators.requiredTrue]],
                    // terms2: [false, [Validators.required, Validators.requiredTrue]],
                }),
            });

            this.forms.push(index0Group);
            this.forms.push(index1Group);
            this.forms.push(index2Group);
            this.forms.push(index3Group);
            this.forms.forEach((form) => {
                this.clearValidators(form);
            });
            this.setValidators(this.forms[0].get("individualControls"));
            this.setValidators(this.forms[0].get("cooperationControls"));
            if(this.sector != "Private") this.setValidators(this.forms[1].get("category.dropDown"));
            this.setValidators(this.forms[1].get("category.area"));
            this.setValidators(this.forms[1].get("hasContactedOptionControls.storeService"));
            this.setValidators(this.forms[2].get("phoneControls"));
            this.setValidators(this.forms[3].get("termsControls"));
        }
    }

    attachmentChange(){
        if (!this._isPlatformServer) {
            setTimeout(() => {this.swiper.update();}, 10);
        }
    }

    clearValidators(formOrControl: AbstractControl): void {
        if (formOrControl instanceof FormGroup) {
            Object.keys(formOrControl.controls).forEach((key) => {
                const control = formOrControl.controls[key];

                if (key === "toggles") {
                    return;
                }

                if (control instanceof FormGroup || control instanceof FormControl) {
                    this.clearValidators(control);
                }
            });
        } else if (formOrControl instanceof FormControl) {
            if (formOrControl.value) {
                formOrControl.reset();
            }
            formOrControl.removeValidators(Validators.required);
            formOrControl.updateValueAndValidity();
        }
    }

    setValidators(formOrControl: AbstractControl): void {
        if (formOrControl instanceof FormGroup) {
            Object.keys(formOrControl.controls).forEach((key) => {
                const control = formOrControl.controls[key];
                if (control instanceof FormGroup || control instanceof FormControl) {
                    this.setValidators(control);
                }
            });
        } else if (formOrControl instanceof FormControl) {
            formOrControl.addValidators(Validators.required);
            formOrControl.updateValueAndValidity();
        }
    }

    onSelectionChange(resetControl: string, setControl?: string) {
        if (!this._isPlatformServer) {
            if (resetControl) {
                this.clearValidators(this.forms[this.swiper.activeIndex].get(resetControl));
            }
            if (setControl) {
                this.forms[this.swiper.activeIndex].get(setControl).markAsUntouched();

                this.clearValidators(this.forms[this.swiper.activeIndex].get(setControl));
                this.setValidators(this.forms[this.swiper.activeIndex].get(setControl));
                if(setControl=='hasContactedOptionControls'){
                    this.clearValidators(this.forms[this.swiper.activeIndex].get('hasContactedOptionControls.person'));
                }
            }
            setTimeout(() => {this.swiper.update();}, 10);
        }
    }

    prevSlide() {
        if (!this._isPlatformServer) {
            for (let i = this.progressBar.nativeElement.children.length - 1; i >= 0; i--) {
                if (this.progressBar.nativeElement.children[i].classList.contains("active")) {
                    this.progressBar.nativeElement.children[i].classList.remove("active");
                    break;
                }
            }
            this.swiper.slidePrev();
        }
    }

    nextSlide() {
        if (!this._isPlatformServer) {
            if (this.forms[this.swiper.activeIndex].invalid) {
                this.forms[this.swiper.activeIndex].markAllAsTouched();
                setTimeout(() => {this.swiper.update();}, 10);
            }else {
                this.progressBarUpdate();
                this.swiper.slideNext();
                
            }
        }
    }

    isInputInvalid(form: any, controlName: string): boolean {
        return form.get(controlName).invalid && form.get(controlName).touched && form.get(controlName).touched;
    }

    SubmitForm(){
        if (this.forms[this.swiper.activeIndex].invalid) {
            this.forms[this.swiper.activeIndex].markAllAsTouched();
            setTimeout(() => {this.swiper.update();}, 10);
        }else {
            
            this.LoadingOnSubmit = true;
            this.reCaptchaSubscription = this.recaptchaV3Service.execute('formSubmission').subscribe(
                (token) => {

                    let option;
                    if(this.forms[1]?.value?.category?.dropDown){
                        option = this.options.filter(x=> { return x.value == this.forms[1]?.value?.category?.dropDown});
                        option = option[0].text;

                    }
                    var request = {                    
                        Name: this.forms[0]?.value?.individualControls?.name,
                        Surname: this.forms[0]?.value?.individualControls?.surname,
                        Fathername: this.forms[0]?.value?.individualControls?.fatherName,
                        Cooperation: this.forms[0]?.value?.toggles?.cooperation,
                        Companyname: this.forms[0]?.value?.companyControls?.companyName,
                        Representantive: this.forms[0]?.value?.companyControls?.representative,
                        IndividualorCompany: this.forms[0]?.value?.toggles?.individualorCompany,
                        VAT: this.forms[0]?.value?.cooperationControls?.tin,
                        Dropdown: option,
                        Area: this.forms[1]?.value?.category?.area,
                        Files: this.forms[1]?.value?.category?.files,
                        Person: this.forms[1]?.value?.hasContactedOptionControls?.person,
                        StoreService: this.forms[1]?.value?.hasContactedOptionControls?.storeService,
                        HasContacted: this.forms[1]?.value?.toggles?.hasContacted,
                        Telephone: this.forms[2]?.value?.phoneControls?.phone,
                        Email: this.forms[2]?.value?.emailControls?.email,
                        Url: document?.location?.href,
                        // TimeSpan: this.timeSpan,
                        reCaptchaV3Token: token,
                        WayofCommunication: this.forms[2]?.value?.toggles?.wayofCommunication,
                        EmailFrom: this.EmailFrom.value,
                        EmailTo: this.EmailTo.value,
                        // Terms1: this.forms[3]?.value?.termsControls?.terms1,
                        // Terms2: this.forms[3]?.value?.termsControls?.terms2,
                    };
        
                    this.apiService.fetch<any>("/piraeusapi/forms/contactForm/submitcontactform", request).then((resp) => {
                        if (resp.status === 200) {
                            this.callSuccess = true;
                        }
                    }).finally(() => {
                        this.swiper.slideNext();
                        this.LoadingOnSubmit =false;
                    });
                });
           
        }
    }

    closeModal(): void {
        if (!this._isPlatformServer) {
            if (this.el) {
                this.fadeOut(this.el.nativeElement.querySelector(".pb-contactFormModal"));
                this.el.nativeElement.querySelector(".pb-contact-modal").classList.remove("pb-scaleUp");
                this.el.nativeElement.querySelector(".pb-contact-modal").classList.add("pb-scaleDown");
                document.querySelector<HTMLElement>("body").classList.remove("pb-overflow-y-hidden");
            }
            this.swiper.slideTo(0);
            this.forms = [];
            this.initializeForm();
            this.individualorCompanyOption = "Individuals";
            this.cooperationOption = "yes";
            this.contactedOption = "yes";
            this.wayofCommunicationOption = "phone";

            this.formDropdownComponents.forEach(component => {component.reset(component.id);});

            const progressBarItems = Array.from(this.progressBar.nativeElement.children);
            progressBarItems.slice(1).forEach(element => {
                element.classList.remove('active');
            });
        }
    }

    fadeOut(element: HTMLElement) {
        if (!this._isPlatformServer) {
            let opacity = 1;
            let duration = 500;
            const interval = 16;
            const decrement = interval / duration;

            function tick() {
                opacity -= decrement;
                element.style.opacity = String(opacity);

                if (opacity <= 0) {
                    element.style.display = "none";
                    clearInterval(timer);
                }
            }

            const timer = setInterval(tick, interval);
        }
    }

    // SelectTime(event: any): void {
    //     event.preventDefault();
    //     if (!this._isPlatformServer) {
    //         Array.from(event.target.parentElement.children).forEach((element : HTMLElement) => {
    //             element.classList.remove('pb-time-checked');
    //           });
    //           event.target.classList.add('pb-time-checked');
    //           this.timeSpan = event.target.innerText;
    //     }
    // }

    progressBarUpdate(): void {
        if (!this._isPlatformServer) {
            for (let i = 1; i < this.progressBar.nativeElement.children.length; i++) {
                if (!this.progressBar.nativeElement.children[i].classList.contains("active")) {
                    this.progressBar.nativeElement.children[i].classList.add("active");
                    break;
                }
            }
        }
    }

    ngOnDestroy(): void {
        if (this.reCaptchaSubscription) {
            this.reCaptchaSubscription.unsubscribe();
        }
      }
}
